<template src="./html/FilterBar.html"></template>

<script>
	import Ladda from 'ladda'
	import Treeselect from '@riophae/vue-treeselect'

	export default {
		props: ['user', 'isAuth', 'filter'],
		components: {
			'treeselect': Treeselect,
		},
		data () {
			return {
				projects: null,
				users: null,

				categories: null,
			}
		},
		created () {
			this.init()
		},
		methods: {
			init() {
				this.getCategories()
			},
			keyUpdoFilter(event) {
				if(this.filter.text) {
					if(event.code == 13) {
						this.doFilter()
					} else {
						if(event.code != 32) {
							this.doFilter()
						}
					}
				} else {
					this.doFilter()
				}
			},
			doFilter() {
				if(this.filter.text) {
					this.filter.text = this.filter.text.trimStart()
				}
				if(this.filter.allowDate) {
					this.filter.date = $('#daterange').val()
				} else {
					this.filter.date = null
				}
				this.$events.fire('filterSet')
			},
			clearData() {
				this.filter.text = null
				this.filter.allowDate = false
				this.filter.data = false
			},
			reset() {
				this.clearData()
				this.$events.fire('filterReset')
			},
			getCategories: function() {
				this.$http.get('admin/management/products/categories')
					.then(response => {
						this.categories = response.body
					})
			},
			normalizerTreeselectCategory(node) {
				return {
					id: node.id,
					label: node.title,
					children: node.children,
				}
			}
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/management/productStorages/views/FilterBar.vue